module.exports = __webpack_public_path__ + "static/media/8.8256cea2.png";